import { IconChevronRight } from "../../icons/IconChevronRight/IconChevronRight";
import { IconRotatingCircle } from "../../icons/IconRotatingCircle/IconRotatingCircle";
import "./DownlineProfileLOS.scss";

interface LOSMarkerProps {
  lineageNumber?: number;
  toggleFlip?: boolean;
  className?: string;
  isLoading?: boolean;
  noLineage?: boolean;
}

const LOSMarker = ({ lineageNumber, toggleFlip = false, className = "", isLoading, noLineage }: LOSMarkerProps) => {
  const hideChevron = noLineage || Number(lineageNumber) <= 1 || isLoading;
  return (
    <>
      <div className={`losMarker ${className}`}>
        <div className="losMarker--dashLine">
          {[...Array(4)].map((_, i) => {
            return <div key={i}></div>;
          })}
        </div>
        <div className={`losMarker--number ${hideChevron ? "losMarker--number--no-lineage" : ""}`}>
          {isLoading ? <IconRotatingCircle variant="medium" /> : <p>{lineageNumber ?? ""}</p>}
          <div
            className={`losMarker--number--chevronRight ${hideChevron ? "losMarker--number--chevronRight--hidden" : ""} ${toggleFlip ? "losMarker--number--chevronRight__flipped" : ""}`}
          >
            <IconChevronRight />
            <IconChevronRight />
          </div>
        </div>
      </div>
    </>
  );
};

export default LOSMarker;
